// zIndexScale.js
//
// The JS mirror of assets/scss/config/saas/_zindex-scale.scss. Same numbers,
// same reasoning — kept here so components that set z-index inline (MUI `sx`,
// react-select's menuPortal, portalled panels) reference the scale instead of
// each re-hardcoding a magic value. If you change one file, change the other.
//
// MUI's scale is the spine, because AppModal is a MUI `Dialog` and we cannot
// move it. Everything else is positioned relative to that 1300.
//
// ⚠️ Raising z-index only helps something already portalled to <body>. An inline
// panel inside AppModal is clipped by DialogContent's `overflow: auto` no matter
// how high its z-index goes. See apps/web/POPUP_LAYERING_AUDIT.md.

const Z_INDEX = {
  drawer: 1200,
  dialog: 1300,
  // A modal opened from *inside* another dialog needs to clear its parent's
  // 1300. It must NOT be pushed to 1400 to achieve that — that is the snackbar
  // tier, and a modal sitting there hides every toast fired while it is open.
  dialogNested: 1320,
  datePicker: 1310,
  // Above the dialog AND the calendar so menus are reachable, but below
  // snackbar/tooltip so a toast still surfaces over an open menu.
  menu: 1350,
  snackbar: 1400,
  tooltip: 1500,
};

export default Z_INDEX;
